module.exports = __webpack_public_path__ + "static/media/icon_arrow_down.e04fd972.svg";